import Api from "@/services/Api";

export default {
  // createStripeCustomer(params: object) {
  //   return Api().post("/users/stripe_customers", params);
  // },
  getLastCardUsed() {
    return Api().get("/users/get_maskedcard");
  },
  saveMaskedCardNo(parmas: any) {
    return Api().put("/users/regist_card", parmas);
  }
};
